import React, { useState, useEffect } from "react";

import {
  Row,
  Col,
  Select,
  Input,
  DatePicker,
  Button,
  Space
} from "antd";

import {
  SearchOutlined,
  ReloadOutlined
} from "@ant-design/icons";
import useClientIDs from "hooks/clientIds/useClientIds";


const { Option } = Select;
const { RangePicker } = DatePicker;

const RateLimitFilters = ({ onSearch }) => {

  const [clientId, setClientId] = useState(null);
  const [outcome, setOutcome] = useState(null);
  const [type, setType] = useState(null);
  const [path, setPath] = useState("");
  const [dateRange, setDateRange] = useState([]);


  const {
    clientIDs,
    fetchClientIDs
  } = useClientIDs(0, 100);

  useEffect(() => {
    fetchClientIDs();
  }, []);

  // search
  const handleSearch = () => {

    const filters = {};

    if (clientId)
      filters.clientId = clientId;

    if (outcome)
      filters.outcome = outcome;

    if (type)
      filters.type = type;

    if (path && path.trim().length >= 2)
      filters.path = path.trim();

    if (dateRange?.length === 2) {

      filters.from =
        dateRange[0].toISOString();

      filters.to =
        dateRange[1].toISOString();
    }

    onSearch(filters);

  };


  // reset
  const handleReset = () => {

    setClientId(null);
    setOutcome(null);
    setType(null);
    setPath("");
    setDateRange([]);

    onSearch({});

  };


  return (

    <Row gutter={[16, 16]}>

      {/* client ID */}
      <Col xs={24} sm={12} md={6}>

        <Select
          placeholder="Select Client"
          allowClear
          showSearch={{
            optionFilterProp: "children"
          }}
          style={{ width: "100%" }}
          value={clientId}
          onChange={setClientId}
        >

          {clientIDs.map((client) => (

            <Option
              key={client.id}
              value={client.id}
            >
              {client.id.substring(0, 8)}...
            </Option>

          ))}

        </Select>

      </Col>

      {/* outcome */}
      <Col xs={24} sm={12} md={4}>

        <Select
          placeholder="Outcome"
          allowClear
          style={{ width: "100%" }}
          value={outcome}
          onChange={setOutcome}
        >

          <Option value="BLOCKED">
            BLOCKED
          </Option>

          <Option value="ALLOWED">
            ALLOWED
          </Option>

        </Select>

      </Col>

      {/* type */}
      <Col xs={24} sm={12} md={4}>

        <Select
          placeholder="Type"
          allowClear
          style={{ width: "100%" }}
          value={type}
          onChange={setType}
        >

          <Option value="PATH">
            PATH
          </Option>

          <Option value="GLOBAL">
            GLOBAL
          </Option>

        </Select>

      </Col>

      {/* path */}
      <Col xs={24} sm={12} md={6}>

        <Input
          placeholder="Search Path"
          value={path}
          onChange={(e) =>
            setPath(e.target.value)
          }
          allowClear
        />

      </Col>

      {/* date range */}
      <Col xs={24} sm={12} md={6}>

        <RangePicker
          showTime
          style={{ width: "100%" }}
          value={dateRange}
          onChange={setDateRange}
        />

      </Col>

      {/* buttons */}
      <Col span={24}>

        <Space>

          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearch}
          >
            Search
          </Button>

          <Button
            icon={<ReloadOutlined />}
            onClick={handleReset}
          >
            Reset
          </Button>

        </Space>

      </Col>

    </Row>

  );

};

export default RateLimitFilters;